import { AbstractWidget } from "../utils/AbstractWidget";
import Findability from "../components/findability/Findability";

export default class FindabilityWidget extends AbstractWidget {
    get UIComponent() {
        return Findability;
    }
}
